import { angelopolisApi } from "../../api/angelopolisAPi";
import { ExclusiveContadoCotizador } from "./ExclusiveContadoCotizador";

export class AsesorCotizador {
  constructor() {
    if (AsesorCotizador.instance) {
      return AsesorCotizador.instance;
    }
    AsesorCotizador.instance = this;
    this.angelopolisApi = new angelopolisApi();
    this.modalSpecialCotizador = new ExclusiveContadoCotizador();
    // this.infoPrice se rellena cuando se termina de sacar los calculos en ModalController.js
    this.infoPrice = {};
    this.infoPriceDefault = {};
    this.infoSeller = {};
    this.defaultMesesSI = 0;
    this.isChangedMSI = false;
    this.viewOne = document.querySelector("#view-1");
    this.viewTwo = document.querySelector("#view-2");
    this.viewThree = document.querySelector("#view-3");
    this.modalAsesorPdf = document.querySelector("#modalAsesorPdf");
    this.btnCancel = document.querySelector("#btn-cancel-modalPDF");
    this.btnCancelinfouser = document.querySelector("#btn-cancel-modalt");
    this.btnLogin = document.querySelector("#btn-next-loginAsesor");
    this.inputUser = document.querySelector("#input-username");
    this.inputPassword = document.querySelector("#input-password");

    this.clientName = document.querySelector("#client-name");

    this.advicenewprice = document.querySelector("#advice-new-price");
    this.advicenewmsi = document.querySelector("#advice-new-msi");

    this.clientPhone = document.querySelector("#client-phone");
    this.clientEmail = document.querySelector("#client-email");
    this.btnClientInfo = document.querySelector("#btn-next-userinfo");

    this.outputprice = document.querySelector("#output-price");
    this.inputdiscount = document.querySelector("#input-discount");
    this.outputAmountDiscount = document.querySelector(
      "#output-amount-discount"
    );
    this.btnApliIscount = document.querySelector("#btn-apli-iscount");
    this.btnDowload = document.querySelector("#btn-dowload");
    this.btnaplimsi = document.querySelector("#btn-apli-msi");
    this.btnCancelModalf = document.querySelector("#btn-cancel-modalf");
    this.outputlotename = document.querySelector("#output-lote-name");
    this.outputenganche = document.querySelector("#output-enganche");
    this.outputmsi = document.querySelector("#output-msi");
    this.outputmensualidad = document.querySelector("#output-mensualidad");

    this.inputpricecuota = document.querySelector("#input-price-cuota");
    this.advicediscount = document.querySelector("#advice-discount");

    this.closeone = document.querySelector("#close-one");
    this.closetwo = document.querySelector("#close-two");
    this.closethree = document.querySelector("#close-three");

    this.alertError = document.querySelector("#error-login-asesor");

    this.displayMenudiscount = document.querySelector("#display-menudiscount");
    this.clikmenudiscount = document.querySelector("#clik-menu-discount");

    this.clikmenumsi = document.querySelector("#clik-menu-msi");
    this.displaymsi = document.querySelector("#display-msi");

    this.inputmsi = document.querySelector("#input-msi");
    this.outputlotenewmeses = document.querySelector("#output-lote-new-meses");
    this.outputlotenewmensualidadMSI = document.querySelector(
      "#output-lote-new-mensualidadMSI"
    );
    this.advicemsi = document.querySelector("#advice-msi");
    this.imgokmsi = document.querySelector("#img-ok-msi");
    this.imgokdiscount = document.querySelector("#img-ok-discount");
    this.alertresetmonts = document.querySelector("#alert-reset-monts");

    this.initListeners();
  }

  initListeners() {
    this.clikmenudiscount.addEventListener("click", () => {
      if (this.displayMenudiscount.classList.contains("hidden")) {
        this.displayMenudiscount.classList.remove("hidden");
      } else {
        this.displayMenudiscount.classList.add("hidden");
      }
    });
    this.clikmenumsi.addEventListener("click", () => {
      if (this.displaymsi.classList.contains("hidden")) {
        this.displaymsi.classList.remove("hidden");
      } else {
        this.displaymsi.classList.add("hidden");
      }
      if (this.alertresetmonts.classList.contains("flex")) {
        this.alertresetmonts.classList.replace("flex", "hidden");
      }
    });

    this.btnCancel.addEventListener("click", () => {
      this.closeModal();
    });
    this.btnCancelinfouser.addEventListener("click", () => {
      this.closeModal();
    });
    this.btnCancelModalf.addEventListener("click", () => {
      // rturn
      this.viewThree.classList.add("hidden");
      this.viewTwo.classList.remove("hidden");
    });
    this.btnLogin.addEventListener("click", () => {
      this.login();
    });
    this.btnClientInfo.addEventListener("click", () => {
      this.passToViewDiscount();
    });
    this.inputdiscount.addEventListener("change", (value) => {
      // console.log(value.target.valueAsNumber);
      this.toggleBtnDiscount(value.target.valueAsNumber >= 1);
    });
    this.inputmsi.addEventListener("change", (value) => {
      // console.log(value.target.valueAsNumber);
      this.toggleBtnMSI(value.target.valueAsNumber >= 1);
    });

    this.btnApliIscount.addEventListener("click", () => {
      this.aplyDiscount();
    });

    this.btnaplimsi.addEventListener("click", () => {
      this.applyMoreMSI();
    });

    this.btnDowload.addEventListener("click", () => {
      this.onGeneratePdf();
    });
    this.inputpricecuota.addEventListener("change", (value) => {
      // console.log(value.target.valueAsNumber);
      this.infoPrice.maintenanceMount = value.target.valueAsNumber;
      if (value.target.valueAsNumber >= 1) {
        this.btnDowload.disabled = false;
        this.btnDowload.classList.replace("bg-[#8B8B8B]", "bg-[#ED2F37]");
        this.btnDowload.classList.replace(
          "border-[#8B8B8B]",
          "border-[#ED2F37]"
        );
      } else {
        this.btnDowload.disabled = true;
        this.btnDowload.classList.replace("bg-[#ED2F37]", "bg-[#8B8B8B]");
        this.btnDowload.classList.replace(
          "border-[#ED2F37]",
          "border-[#8B8B8B]"
        );
      }
    });

    this.closeone.addEventListener("click", () => {
      this.closeModal();
    });
    this.closetwo.addEventListener("click", () => {
      this.closeModal();
    });
    this.closethree.addEventListener("click", () => {
      this.closeModal();
    });
  }

  openModal() {
    this.modalAsesorPdf.classList.replace("hidden", "flex");
    this.outputlotenewmensualidadMSI.innerText = `${this.infoPrice.plazo} MSI`;
    console.log(this.infoPrice);
  }

  closeModal() {
    // this.infoPrice = {};
    // this.infoPriceDefault = {};
    this.inputpricecuota.value = 0;
    this.clientName.value = "";
    this.clientPhone.value = "";
    this.clientEmail.value = "";
    this.inputdiscount.value = 0;
    this.inputmsi.value = 0;
    this.btnDowload.disabled = true;
    this.imgokmsi.classList.add("hidden");
    this.imgokdiscount.classList.add("hidden");
    this.defaultMesesSI = 0;
    this.modalAsesorPdf.classList.replace("flex", "hidden");
    this.advicenewprice.classList.replace("flex", "hidden");
    this.advicenewmsi.classList.replace("flex", "hidden");
    this.viewOne.classList.remove("hidden");
    this.viewTwo.classList.add("hidden");
    this.viewThree.classList.add("hidden");
  }

  aplyDiscount() {
    if (this.inputdiscount.value >= 50 || this.inputdiscount.value < 0) {
      alert("Error: Fuera de rango");
    } else {
      this.advicenewprice.classList.replace("hidden", "flex");
      this.aplyDefaultMSI();
      this.imgokdiscount.classList.remove("hidden");
      let discount = this.inputdiscount.value;
      console.log(discount);
      this.infoPrice.priceMeter =
        this.infoPriceDefault.priceMeter -
        this.infoPriceDefault.priceMeter * (discount / 100);

      this.infoPrice.engancheAmount =
        this.infoPriceDefault.engancheAmount -
        this.infoPriceDefault.engancheAmount * (discount / 100);

      this.infoPrice.mensualidad =
        this.infoPriceDefault.mensualidad -
        this.infoPriceDefault.mensualidad * (discount / 100);

      this.infoPrice.priceFinal =
        this.infoPriceDefault.priceFinal -
        this.infoPriceDefault.priceFinal * (discount / 100);

      this.infoPrice.priceFinancial =
        this.infoPriceDefault.priceFinancial -
        this.infoPriceDefault.priceFinancial * (discount / 100);

      this.outputAmountDiscount.innerText = this.convertToFormat(
        this.infoPrice.priceFinal
      );

      this.infoPrice.mountContraEntrega =
        this.infoPriceDefault.mountContraEntrega -
        this.infoPriceDefault.mountContraEntrega * (discount / 100);

      this.advicediscount.classList.replace("hidden", "flex");
      setTimeout(() => {
        this.advicediscount.classList.replace("flex", "hidden");
      }, 1000);
    }
  }

  applyMoreMSI() {
    if (this.inputmsi.value >= 60 || this.inputmsi.value < 0) {
      alert("Error: Fuera de rango");
    } else {
      this.advicenewmsi.classList.replace("hidden", "flex");
      this.isChangedMSI = true;
      let mesesMore = this.inputmsi.value;
      this.infoPrice.plazo =
        parseInt(this.defaultMesesSI) + parseInt(mesesMore);

      this.infoPrice.mensualidad =
        (this.infoPrice.priceFinancial *
          (this.infoPrice.mensualidadValue / 100)) /
        this.infoPrice.plazo;

      this.outputlotenewmeses.innerText = this.convertToFormat(
        this.infoPrice.mensualidad
      );
      this.outputlotenewmensualidadMSI.innerText = `${this.infoPrice.plazo} MSI`;
      this.imgokmsi.classList.remove("hidden");
      this.advicemsi.classList.replace("hidden", "flex");
      setTimeout(() => {
        this.advicemsi.classList.replace("flex", "hidden");
      }, 1000);
    }
  }

  aplyDefaultMSI() {
    if (this.inputdiscount.value >= 1 && this.isChangedMSI) {
      this.alertresetmonts.classList.replace("hidden", "flex");
    }
    this.advicenewmsi.classList.replace("flex", "hidden");
    this.imgokmsi.classList.add("hidden");
    this.infoPrice.plazo = parseInt(this.defaultMesesSI);
    this.inputmsi.value = 0;
    this.infoPrice.mensualidad =
      (this.infoPrice.priceFinancial *
        (this.infoPrice.mensualidadValue / 100)) /
      this.defaultMesesSI;

    this.outputlotenewmeses.innerText = this.convertToFormat(
      this.infoPrice.mensualidad
    );
    this.outputlotenewmensualidadMSI.innerText = `${this.infoPrice.plazo} MSI`;
  }

  toggleBtnDiscount(isEnable) {
    if (isEnable) {
      this.btnApliIscount.classList.replace("bg-[#8B8B8B]", "bg-white");
      this.btnApliIscount.classList.replace(
        "border-[#8B8B8B]",
        "btn-gradient-1"
      );
      this.btnApliIscount.classList.replace("text-white", "text-black");
    } else {
      this.btnApliIscount.classList.replace("bg-white", "bg-[#8B8B8B]");
      this.btnApliIscount.classList.replace(
        "btn-gradient-1",
        "border-[#8B8B8B]"
      );
      this.btnApliIscount.classList.replace("text-black", "text-white");
    }
  }

  toggleBtnMSI(isEnable) {
    if (isEnable) {
      this.btnaplimsi.classList.replace("bg-[#8B8B8B]", "bg-white");
      this.btnaplimsi.classList.replace("border-[#8B8B8B]", "btn-gradient-1");
      this.btnaplimsi.classList.replace("text-white", "text-black");
    } else {
      this.btnaplimsi.classList.replace("bg-white", "bg-[#8B8B8B]");
      this.btnaplimsi.classList.replace("btn-gradient-1", "border-[#8B8B8B]");
      this.btnaplimsi.classList.replace("text-black", "text-white");
    }
  }

  toggleErrorLogin(isActive) {
    isActive
      ? this.alertError.classList.replace("hidden", "flex")
      : this.alertError.classList.replace("flex", "hidden");
  }

  passToViewDiscount() {
    console.clear();
    if (
      this.clientName.value === "" ||
      this.clientPhone.value === "" ||
      this.clientEmail.value === "" ||
      !this.infoSeller.name
    ) {
      alert("Revisa los campos");
    } else {
      this.infoPriceDefault = { ...this.infoPrice };
      this.outputlotename.innerText = this.infoPrice.loteinfo.NombreBusqueda;
      this.defaultMesesSI = this.infoPrice.plazo;
      console.log(this.infoPrice);
      this.outputenganche.innerText = this.convertToFormat(
        this.infoPrice.engancheAmount
      );
      this.outputmsi.innerText = `${this.infoPrice.plazo} Meses`;
      this.outputmensualidad.innerText = this.convertToFormat(
        this.infoPrice.mensualidad
      );

      this.outputprice.innerText = this.convertToFormat(
        this.infoPrice.priceFinal
      );
      this.outputAmountDiscount.innerText = this.convertToFormat(
        this.infoPrice.priceFinal
      );
      // si es un precio de contado
      // abre un modal especifico con campso especificos para contado
      if (this.infoPrice.notDicountPlazo === 0) {
        this.viewTwo.classList.add("hidden");
        this.modalSpecialCotizador.enableModal(this.infoPrice, {
          clientName: this.clientName.value,
          clientPhone: this.clientPhone.value,
          clientEmail: this.clientEmail.value,
          ...this.infoSeller,
        });
        this.closeModal();
        //
        //
      } else {
        this.viewTwo.classList.add("hidden");
        this.viewThree.classList.remove("hidden");
      }
    }
  }

  pastoViewTwo() {
    this.modalAsesorPdf.classList.replace("hidden", "flex");
    this.viewOne.classList.add("hidden");
    this.viewTwo.classList.remove("hidden");
  }

  async login() {
    this.toggleErrorLogin(false);
    const username = this.inputUser.value;
    const password = this.inputPassword.value;
    if (username === "" || password === "") {
      this.toggleErrorLogin(true);
    } else {
      const result = await this.angelopolisApi.onLogin(username, password);
      if (result.status === 0 && result.msg === "ok") {
        this.toggleErrorLogin(false);
        this.inputPassword.value = "";
        this.infoSeller = result.payload.user;
        this.pastoViewTwo();
      } else {
        this.toggleErrorLogin(true);
      }
    }
  }

  async onGeneratePdf() {
    console.clear();
    const clientName = this.clientName.value;
    const clientPhone = this.clientPhone.value;
    const clientEmail = this.clientEmail.value;
    if (
      clientName === "" ||
      clientPhone === "" ||
      clientEmail === "" ||
      !this.infoSeller.name
    ) {
      alert("Revisa los campos");
    } else {
      // corection anme ligarcadia error cms
      let clusterNameFixed = "";
      if (
        this.infoPrice.loteinfo.CodigoProducto.split(" ")[0] === "LIGARCADIA"
      ) {
        clusterNameFixed = "Arcadia";
      } else {
        clusterNameFixed = this.infoPrice.loteinfo.CodigoProducto.split(" ")[0];
      }

      const formatedApiBody = {
        date: new Date(),
        type: this.infoPrice.type,
        discountAplicated: this.inputdiscount.value,
        asesorName: this.infoSeller.name,
        asesorPhone: this.infoSeller.phone,
        asesorEmail: this.infoSeller.email,
        interestedName: clientName,
        interestedPhone: clientPhone,
        interestedEmail: clientEmail,
        planeImg: this.infoPrice.loteinfo.image,
        clusterName: clusterNameFixed,
        loteDirection: this.infoPrice.loteinfo.NombreBusqueda,
        dimensionsLote: this.infoPrice.loteinfo.meters,
        priceMeter: this.convertToFormat(this.infoPrice.priceMeter),
        priceFinancial: this.convertToFormat(this.infoPrice.priceFinancial),
        engancheValue: this.infoPrice.engancheValue,
        engancheAmount: this.convertToFormat(this.infoPrice.engancheAmount),
        plazo: this.infoPrice.plazo,
        mensualidad: this.convertToFormat(this.infoPrice.mensualidad),
        priceFinal: this.convertToFormat(this.infoPrice.priceFinal),
        mensualidadValue: this.infoPrice.mensualidadValue,
        maintenanceMount: this.convertToFormat(this.infoPrice.maintenanceMount),
        percentageContraEntrega: this.infoPrice.percentageContraEntrega,
        mountContraEntrega: this.convertToFormat(
          this.infoPrice.mountContraEntrega
        ),
        notDicountPlazo: this.infoPrice.notDicountPlazo,
        notDiscountpriceMeter: this.convertToFormat(
          this.infoPrice.notDiscountpriceMeter
        ),
        notDiscountenganche: this.convertToFormat(
          this.infoPrice.notDiscountenganche
        ),
        notDiscountContraenetrega: this.convertToFormat(
          this.infoPrice.notDiscountContraenetrega
        ),
        notDiscountmenusalidad: this.convertToFormat(
          this.infoPrice.notDiscountmenusalidad
        ),
        notDiscountpriceFinancial: this.convertToFormat(
          this.infoPrice.notDiscountpriceFinancial
        ),
      };
      console.log(formatedApiBody);
      const result = await this.angelopolisApi.onGeneratePDfApi(
        formatedApiBody
      );
      if (result.payload.ok) {
        window.open(result.payload.path, "_blank");
        // this.closeModal();
      }
    }
  }

  convertToFormat(number) {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  // hiddenModalLoading() {
  //   this.loadingModal.classList.add("hidden");
  // }
}
